import React from 'react';

interface FormLabelProps {
  htmlFor?: string;
  required?: boolean;
  children: React.ReactNode;
}

export const FormLabel: React.FC<FormLabelProps> = ({ htmlFor, required, children }) => (
  <label htmlFor={htmlFor}>
    {children}
    {required && <span className="required-marker" aria-hidden="true"> *</span>}
  </label>
);
